export default {"src":"/_next/static/media/es.15d8cfb3.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};